import { useCallback } from 'react'
import { useScrollOffset } from './use-scroll-offset'

// Maybe we can do this in with refs?

export const useAnchorLinkScroll = () => {
  const { scrollOffset } = useScrollOffset()

  const scrollToId = useCallback(
    (id: string, offset = 0) => {
      const target = document.getElementById(id)

      if (!target) return

      const boundingBox = target.getBoundingClientRect()

      if (boundingBox) {
        const top = boundingBox.top + window.pageYOffset - scrollOffset.top + offset

        window.scrollTo({ top })
      }
    },
    [scrollOffset]
  )

  const anchorOnClick =
    (id: string, offset = 0) =>
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault()

      scrollToId(id, offset)
    }

  const buttonOnClick = (id: string, offset = 0) => {
    scrollToId(id, offset)
  }

  return { anchorOnClick, buttonOnClick }
}

export default useAnchorLinkScroll
